<div class="sidebar bg-body-tertiary" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
    <div id="homelogo" aria-labelledby="homelogo" (click)="navTo('/')">
        <img class="w-100" src="/assets/img/Bidvest_400x185.svg" alt="mccarthylogo.png">
    </div>
    <div id="appname"
        class="text-center text-light mx-auto my-4 pb-2 w-fit-content border-bottom border-3 border-secondary"
        aria-labelledby="appname">
        <span class="prevent-select">Supplier<br />Onboarding</span>
    </div>
    <div class="list-group list-group-flush bg-body-tertiary overflow-auto">
        <!-- <button type="button" class="list-group-item list-group-item-action" [ngClass]="currentRoute=='Dashboard'?'active':'bg-body-tertiary'"
        (click)="navTo('/')" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu"
        ngbTooltip="Dashboard" placement="right" [openDelay]="500" [closeDelay]="500">
            <i class="bi bi-bar-chart-fill me-2"></i>Dashboard
        </button> -->

        <button type="button" class="list-group-item list-group-item-action"
            [ngClass]="currentRoute=='Approval List'?'active':'bg-body-tertiary'" (click)="navTo('/')"
            data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" ngbTooltip="Dashboard" placement="right"
            [openDelay]="500" [closeDelay]="500">
            <i class="bi bi-clipboard-check-fill me-2"></i>Dashboard
        </button>

        <button type="button" class="list-group-item list-group-item-action"
            [ngClass]="currentRoute=='Suppliers'?'active':'bg-body-tertiary'" (click)="navTo('/suppliers')"
            data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" ngbTooltip="Suppliers" placement="right"
            [openDelay]="500" [closeDelay]="500">
            <i class="bi bi-person-fill me-2"></i>Suppliers
        </button>

        @if (UserRoleGroups.isSuperAdmin()) {
        <button type="button" class="list-group-item list-group-item-action"
            [ngClass]="currentRoute=='Admin'?'active':'bg-body-tertiary'" (click)="navTo('/admin')"
            data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" ngbTooltip="Admin" placement="right"
            [openDelay]="500" [closeDelay]="500">
            <i class="bi bi-person-fill-gear me-2"></i>Admin
        </button>
        }
    </div>
</div>